const messages = {
  seasons: {
    all: "All Season",
    summer: "Summer",
    winter: "Winter",
    general: "General",
  },
  offer:
    "We regularly expand our <br />offers for you! <br /><br />We will inform you about new training courses in your inbox.",
  summary: {
    congratulations: "CONGRATULATIONS - YOU HAVE COMPLETED YOUR EXPERTISE ON",
    participation:
      "You have successfully completed the Transporter All-Season Tires Online Training.",
    certificate:
      "Your certificate will be sent to you by email or you can download it directly as a PDF here:",
    send: "Download certificate",
  },
  online: {
    title: "Our online trainings",
    desc: "Secure expert knowledge and, upon successful completion of the respective tests for the training, your<br> personal participation certificate as well as 40 extra points for the premium club for the first time",
    content:
      "Discover our current online trainings now and participate immediately on the platform here:",
    categories: {
      title: "Online Training",
      description:
        "Stay ahead with knowledge: Secure exclusive expertise for you and your team with our training offerings. Whether it's our online training sessions, which you can participate in directly on the platform, our courses and practical seminars at the Bridgestone Training Center, or even external training sessions whose costs you can reduce with your premium points.",
      general: {
        title: "General",
        subtitle: "Online Training: General",
        description:
          "Discover the latest technologies, important developments in the tire industry, tips for your sales pitch, and more.",
        subdesription:
          "Secure expert knowledge and, upon successful completion of the respective training tests, your personal certificate of participation as well as a one-time bonus of 40 extra points for the premium club.",
      },
      product: {
        title: "Products",
        subtitle: "Online Training: Products",
        description:
          "Deepen your Bridgestone and Firestone product expertise for successful sales with our compact training videos.",
        subdesription:
          "Secure expert knowledge and, upon successful completion of the respective training tests, your personal certificate of participation as well as a one-time bonus of 40 extra points for the premium club.",
      },
    },
  },
  lectures: {
    title: "Bridgestone trainings",
    desc: "Expand your expertise and book our trainings and intensive trainings for yourself and your team. You have the option of participating in the trainings at the Bridgestone Competence and Training Center in Dietzenbach (near Frankfurt am Main) or, for selected trainings, having them carried out at your company. You can use your bonus points for the trainings and thus offset the costs in whole or in part with your points.",
    content: "Discover our current trainings now and request a booking:",
  },
  singleLecture: {
    registerForm: {
      title: "Training contents",
      inquiry: "Inquiry",
      interested: "I am interested in the training",
      participantsNr: "Number of participants",
      pointsFromBalance: "I want to use points from my points balance.",
      reduction: "This corresponds to a cost reduction of {points} euros.",
      request: "Send request",
    },
    success: {
      thanks: "Thank you",
      title: "Your inquiry has been sent to the training team.",
      feedbackTime:
        "You will receive a response within 14 days to clarify all details.",
      points:
        "The bonus points used in the amount of<br /><strong>{points}</strong> points have been deducted from your<br />points account.",
      refund:
        "If the training does not take place, the points will of course be credited back to you.",
      queries: "For questions, please contact:",
    },
    index: {
      costs: "Costs and participation information",
      duration: "Duration: {duration}",
      cost: "Costs {cost}: {price} euros",
      participantsNr: "Participants: min. {min} - max. {max} people",
    },
  },
  index: {
    title: "Training and education",
    desc: "Advantage through knowledge: Secure exclusive specialist knowledge for you and your team with our training offers. Whether with our online training, which you can take part in directly on the platform, with our training and practical seminars in the Bridgestone training center or with external training, the costs of which you can reduce with your reward points.",
    online: {
      title: "Online trainings",
      desc: "Participate directly on the platform and secure {points} points for the premium club.",
    },
    lectures: {
      title: "Trainings",
      desc: "High-quality trainings in our training center or at your location.",
    },
    external: {
      title: "External trainings",
      desc: "Use bonus points for offers from third-party providers and reduce costs.",
    },
  },
  single: {
    done: "Koulutus suoritettu.",
    doneDownloadCertificate: "Koulutus suoritettu. Lataa sertifikaatti.",
  },
  certificate: {
    header: "CERTIFICATE",
    atCourse: "has successfully participated in the",
    takePart: "course.",
    contains: "COMPONENTS OF THE COURSE",
    country: "Finland",
  },
};

export default {
  messages,
};
